/** Optional editorial copy supplied by the listing markup. */
export const createFilterDescription = (filter: HTMLElement): HTMLParagraphElement | null => {
  const description = filter.getAttribute("description");
  if (!description) return null;
  const paragraph = document.createElement("p");
  paragraph.className = "ab-products__filter-description";
  paragraph.textContent = description;
  return paragraph;
};
